import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    const headers = {responseType: "arraybuffer"}

    return {
        relatorioEnvio(queryParms) {
            return repository.get(`${baseUrl}/ria-relatorio-envio?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}